import {AxiosInstance, InternalAxiosRequestConfig} from "axios";
import {isObject} from "@/utils/TypeUtil";

/**
 * 要素・要素の配列から配列を生成します
 *
 * @param src 要素・要素の配列
 */
function buildArray<T>(src: T | T[] | null | undefined): T[] {
  const result: T[] = [];
  if(src === null || src === undefined) {
    // nop
  } else if(Array.isArray(src)) {
    Array.prototype.push.apply(result, src);
  } else {
    result.push(src);
  }
  return result;
}

/**
 * オブジェクトのキー名を変更します
 *
 * @param obj 元となるオブジェクト
 * @param map キー名をマップする関数
 */
function mapObjectKey(obj: object, map: (key: string) => string): object {
  const result = {} as any;
  for (const [key, value] of Object.entries(obj)) {
    result[map(key)] = value;
  }
  return result;
}

/**
 * リクエスト用マップ関数
 *
 * @param key キー名
 */
function mapRequest(key: string): string {
  switch(key) {
    case 'issuerTerminalId': return 'proposerTerminalId';
    case 'recipientTerminalId': return 'responderTerminalId';
    case 'proposerTerminalId': return 'presenterTerminalId';
    case 'responderTerminalId': return 'mapperTerminalId';
    case 'issuerRole': return 'proposerRole';
    case 'issuerMapperRole': return 'proposerMapperRole';
    default: return key;
  }
}

/**
 * レスポンス用マップ関数
 *
 * @param key キー名
 */
function mapResponse(key: string): string {
  switch(key) {
    case 'proposerTerminalId': return 'issuerTerminalId';
    case 'responderTerminalId': return 'recipientTerminalId';
    case 'presenterTerminalId': return 'proposerTerminalId';
    case 'mapperTerminalId': return 'responderTerminalId';
    default: return key;
  }
}

/**
 * trade_contracts 関係の HCS 用語を HCM 用語に置き換えるパッチを仕込みます
 *
 * @param axios AxiosInstance
 */
export function applyTradeContractPatch(axios: AxiosInstance): AxiosInstance {
  axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    if(/^(\/assets)?\/(trade_contracts|trade_contract_formats|trade_contract_format_groups)\/?.*$/.test(config.url ?? '')) {
      // リクエストボディーを改変する
      config.transformRequest = buildArray(config.transformRequest);
      config.transformRequest.unshift(data => {
        if(isObject(data)) {
          data = mapObjectKey(data, mapRequest);
          switch(data.proposerMapperRole) {
            case 'proposer':
              data.proposerMapperRole = 'presenter';
              break;
            case 'responder':
              data.proposerMapperRole = 'mapper';
              break;
          }
        }
        return data;
      });

      // レスポンスボディーを改変する
      config.transformResponse = buildArray(config.transformResponse);
      config.transformResponse.push(data => {
        if(data instanceof Blob) {
          return data;
        } else if(Array.isArray(data)) {
          data = data.map(d => mapObjectKey(d, mapResponse))
        } else if(isObject(data)) {
          data = mapObjectKey(data, mapResponse);
        }
        return data;
      });
    }
    return config;
  });
  return axios;
}
